import React from "react";
import LineChart from "../../chart/LineChart";

const TopUserTransmissionChart = ({ chartData, maxCount, getChartOptions }) => {
  return <LineChart options={getChartOptions(maxCount)} data={chartData} />;
};

export default TopUserTransmissionChart;
